import Tooltip from '@anm/components/Tooltip';
import {
  SelectValueContainer,
  SelectWrapper
} from '@anm/components/select/Select';
import styled from 'styled-components';

export const Wrapper = styled.div`
  ${SelectWrapper} {
    padding-bottom: 50px;
  }

  ${SelectValueContainer} {
    flex-shrink: 0;
  }
`;

const TooltipWrapper = styled(Tooltip)`
  left: unset;
  right: 0;
  min-width: 220px;
`;

export default TooltipWrapper;
